<section class="home-estimator-lead-form">
  <div class="home-estimator-lead-form__background"></div>
  <div class="home-estimator-lead-form__absolute-container">
    <div class="home-estimator-lead-form__container">
      <div class="home-estimator-lead-form__form-container">
        <form class="home-estimator-lead-form__form" (ngSubmit)="sendGrecaptcha()" [formGroup]="homeEstimatorForm">
          <h1 class="home-estimator-lead-form__title">{{ 'home-estimator.ready-to-talk' | translate }}</h1>
          <app-input [isRedesign]="true" [formControl]="userName" [parentFormGroup]="homeEstimatorForm" [placeholder]="('contact.name' | translate)"
            inputType="text" inputId="input-name" class="home-estimator-lead-form__input-address home-estimator-lead-form__input-box">
          </app-input>
          <app-input [isRedesign]="true" [formControl]="userEmail" [parentFormGroup]="homeEstimatorForm" [placeholder]="('home-estimator.email' | translate)"  [errorText]="'errors.invalid-email-format' | translate"
            inputType="email" inputId="input-email" [isRequired]="true" class="home-estimator-lead-form__input-address home-estimator-lead-form__input-box">
          </app-input>
          <div class="home-estimator-lead-form__address-container" #addressBarRef [class.no-search-results]="!showSearchResults">
            <app-input [isRedesign]="true" [focus]="focus" [formControl]="userAddress" (onFocus)="onAddressInputClick()" [parentFormGroup]="homeEstimatorForm" [placeholder]="('home-estimator.search-placeholder-mobile' | translate)"
             (onBlur)="onLoseFocus()" [errorText]="'errors.invalid-address-selected' | translate" inputType="text" inputId="input-address" [isRequired]="true" class="home-estimator-lead-form__input-address home-estimator-lead-form__input-box">
            </app-input>
            <div class="home-estimator-lead-form__suggested-searches" [class.hidden]="!showSearchResults">
              <app-search-results *ngIf="showSearchResults"
                                  [locationResults]="locationResults"
                                  (onBlur)="onLoseFocus()"
                                  (selectResult)="onSelectResult($event)"
                                  [isSearchingForResults]="isSearching"
                                  [searchInput]="userAddress"
                                  [showButtons]="showAdditionalActionsButtons">
              </app-search-results>
            </div>
          </div>
          <input class="home-estimator-lead-form__input-submit btn-redesign--primary  btn-redesign--primary" type="submit" [disabled]="!homeEstimatorForm.valid || showRequestSent" [value]="('home-estimator.consult' | translate)">
          <app-recaptcha [onSubmit]="getOnSubmit()" (recaptchaIdCreated)="recaptchaId=$event"></app-recaptcha>
        </form>
      </div>
      <div class="home-estimator-lead-form__video-container">
          <img [src]="'/assets/landing_page/homepage_end_card_sm.jpeg'"/>
      </div>
    </div>
  </div>
</section>
